import React from 'react';
import { PROCEEDING_TYPES } from '../../hooks/useYonotsune.js';
import { getUILoc } from '../../utils/cardUtils.js';
import FrictionEvent from './events/FrictionEvent.js';
import WhimEvent from './events/WhimEvent.js';
import SharpenEvent from './events/SharpenEvent.js';
import DiplomacyEvent from './events/DiplomacyEvent.js';
import OpportunityEvent from './events/OpportunityEvent.js';

const YonotsuneEventResolver = ({ 
  activeRun, 
  cardDefs, 
  onStartMatch, 
  executeWhimExchange, 
  executeSharpenRemove, 
  executeDiplomacyExchange, 
  requestDiplomacyReroll,
  executeOpportunityRemove,
  executeOpportunityDraw,
  startOpportunityBattle,
  goToNextNodeSelection,
  executeCrystal,
  hesitateCrystal
}) => {
  
  // 人文の結晶は即時適用なのでここで処理
  if (activeRun.activeNode === PROCEEDING_TYPES.CRYSTAL) {
    return (
      <div className="event-resolver crystal-event">
        <h2>{getUILoc('YONOTSUNE.EVENTS.CRYSTAL.NAME')}</h2>
        <p className="resolver-intro">
          {getUILoc('YONOTSUNE.EVENTS.CRYSTAL.INTRO')}
        </p>
        <div className="action-row">
          <button className="yonotsune-btn start-btn" onClick={executeCrystal}>
            {getUILoc('YONOTSUNE.EVENTS.CRYSTAL.EXECUTE')}
          </button>
          {activeRun.matchedCount >= 5 && 
            <button className="yonotsune-btn start-btn" onClick={hesitateCrystal}>
            {getUILoc('YONOTSUNE.EVENTS.CRYSTAL.HESITATE')}
            </button>
          }
        </div>
      </div>
    );
  }

  const renderContent = () => {
    switch (activeRun.activeNode) {
      case PROCEEDING_TYPES.FRICTION:
        return <FrictionEvent activeRun={activeRun} onStartMatch={onStartMatch} />;
      
      case PROCEEDING_TYPES.WHIM:
        return (
          <WhimEvent 
            activeRun={activeRun} 
            cardDefs={cardDefs}
            executeWhimExchange={executeWhimExchange} 
            goToNextNodeSelection={goToNextNodeSelection} 
          />
        );
      
      case PROCEEDING_TYPES.SHARPEN:
        return (
          <SharpenEvent 
            activeRun={activeRun} 
            cardDefs={cardDefs}
            executeSharpenRemove={executeSharpenRemove} 
            goToNextNodeSelection={goToNextNodeSelection} 
          />
        );
      
      case PROCEEDING_TYPES.DIPLOMACY:
        return (
          <DiplomacyEvent 
            activeRun={activeRun} 
            cardDefs={cardDefs} 
            executeDiplomacyExchange={executeDiplomacyExchange} 
            requestDiplomacyReroll={requestDiplomacyReroll}
            goToNextNodeSelection={goToNextNodeSelection} 
          />
        );

      case PROCEEDING_TYPES.OPPORTUNITY:
        return (
          <OpportunityEvent
            activeRun={activeRun}
            cardDefs={cardDefs}
            executeOpportunityRemove={executeOpportunityRemove}
            executeOpportunityDraw={executeOpportunityDraw}
            startOpportunityBattle={startOpportunityBattle}
            onStartMatch={onStartMatch}
            goToNextNodeSelection={goToNextNodeSelection}
          />
        );
      
      default:
        return <div>不明なイベントノードです。</div>;
    }
  };

  const getNodeName = (nodeId) => {
    switch(nodeId) {
        case PROCEEDING_TYPES.FRICTION: return getUILoc('YONOTSUNE.EVENTS.FRICTION.NAME');
        case PROCEEDING_TYPES.WHIM: return getUILoc('YONOTSUNE.EVENTS.WHIM.NAME');
        case PROCEEDING_TYPES.SHARPEN: return getUILoc('YONOTSUNE.EVENTS.SHARPEN.NAME');
        case PROCEEDING_TYPES.DIPLOMACY: return getUILoc('YONOTSUNE.EVENTS.DIPLOMACY.NAME');
        case PROCEEDING_TYPES.CRYSTAL: return getUILoc('YONOTSUNE.EVENTS.CRYSTAL.NAME');
        case PROCEEDING_TYPES.OPPORTUNITY: return getUILoc('YONOTSUNE.EVENTS.OPPORTUNITY.NAME');
        default: return nodeId;
    }
  };

  return (
    <div className={`event-resolver-container node-${activeRun.activeNode}`}>
      <div className="resolver-header">
        <h2>{getUILoc('YONOTSUNE.HUD.PHASE')}: {getNodeName(activeRun.activeNode)}</h2>
      </div>

      <div className="resolver-body">
        {renderContent()}
      </div>
    </div>
  );
};

export default YonotsuneEventResolver;
